import Vue from 'vue'
import Router from 'vue-router'
import VueMeta from 'vue-meta'

import Home from '@/views/Home.vue'
import Privacy from '@/views/Privacy.vue'
import Routes from '@/views/Routes.vue'
import Articles from '@/views/Articles.vue'
import Points from '@/views/Points.vue'
import Download from '@/views/Download.vue'
import Help from '@/views/Help.vue'


Vue.use(Router)
Vue.use(VueMeta)

const r = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    
    {
      path: '/privacy',
      name: 'Privacy',
      component: Privacy
    },
    {
      path: '/route/:id',
      name: 'Routes',
      component: Routes
    },
    {
      path: '/download',
      name: 'Download',
      component: Download
    },
    {
      path: '/article/:id',
      name: 'Articles',
      component: Articles
    },
    {
      path: '/point/:id',
      name: 'Points',
      component: Points
    },
    {
      path: '/help',
      name: 'Help',
      component: Help
    }
  ]
})

export default r
